import viugoTrendDown from "@/assets/images/viugo/kbv-v16-trend-arrow-down.svg";
import viugoTrendUp from "@/assets/images/viugo/kbv-v16-trend-arrow-up.svg";
import {
  hasDirectionalTrend,
  isValidOddValue,
  normalizeTrend,
} from "../ViuGoOddsMatchRow/ViuGoTrendUtils";

function TrendArrow({ isDown }) {
  return (
    <img
      src={isDown ? viugoTrendDown : viugoTrendUp}
      alt=""
      width={6}
      height={5}
      className="shrink-0"
      aria-hidden
    />
  );
}

export function TrendOdd({ value, trend }) {
  const normalized = normalizeTrend(trend);
  const isDown = normalized === "down";
  const isUp = normalized === "up";
  const display = isValidOddValue(value) ? value : "-";
  return (
    <span className="inline-flex items-center gap-[3px] tabular-nums">
      <span
        className={
          isDown
            ? "football-trend-down"
            : isUp
              ? "football-trend-up"
              : "text-[var(--theme-highlight,#0B71F9)]"
        }
      >
        {display}
      </span>
      {isValidOddValue(display) && hasDirectionalTrend(trend) && (
        <TrendArrow isDown={isDown} />
      )}
    </span>
  );
}

export function MobileOdd({ value, trend }) {
  const normalized = normalizeTrend(trend);
  const isDown = normalized === "down";
  const isUp = normalized === "up";
  const display = isValidOddValue(value) ? value : "-";
  return (
    <span
      className={
        isDown
          ? "football-trend-down"
          : isUp
            ? "football-trend-up"
            : "text-[var(--theme-highlight,#0B71F9)]"
      }
    >
      {display}
    </span>
  );
}

